import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLanguage } from 'src/LanguageContext';
import { translate } from 'src/translate';
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';

export default function MaterialDropDown({
  updateStaff,
  staffList,
  title,
  choosenStaffId,
  needsTranslation = false,
}) {
  const { language } = useLanguage();

  if (!updateStaff) {
    updateStaff = () => {};
  }

  useEffect(() => {
    updateStaff(choosenStaffId ? choosenStaffId : staffList[0].id);
  }, [choosenStaffId]);

  const [selected, setSelected] = useState(
    choosenStaffId ? staffList.find((e) => e.id === choosenStaffId) : staffList[0],
  );

  const handleChange = (event) => {
    const newSelected = staffList.find((e) => e.id === event.target.value);
    updateStaff(newSelected.id);
    setSelected(newSelected);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">{title}</InputLabel>
      <Select
        MenuProps={{ style: { zIndex: 1900 } }}
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={selected.id}
        label={title}
        onChange={handleChange}
        renderValue={(selectedId) => {
          const selectedItem = staffList.find((e) => e.id === selectedId);
          return needsTranslation ? translate(selectedItem?.name, language) : selectedItem?.name;
        }}
      >
        {staffList.map((person) => (
          <MenuItem key={person.id} value={person.id}>
            {needsTranslation ? translate(person.name, language) : person.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
